<template>
  <a-popover
    :arrowPointAtCenter="true"
    :autoAdjustOverflow="true"
    :overlayStyle="{ width: '300px', top: '50px' }"
    @visibleChange="handleHoverChange"
    overlayClassName="header-notice-wrapper"
    placement="bottomRight"
    trigger="click"
  >
    <template slot="content">
      <a-spin :spinning="loadding">
        <a-tabs>
          <a-tab-pane :tab="msg1Title" key="1">
            <!--<a-list>
              <a-list-item>
                <a-list-item-meta title="你收到了 14 份新周报" description="一年前">
                  <a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"/>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta title="你推荐的 IT大牛 已通过第三轮面试" description="一年前">
                  <a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png"/>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta title="这种模板可以区分多种通知类型" description="一年前">
                  <a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>-->
            <a-list>
              <a-list-item :key="index" v-for="(record, index) in announcement1">
                <div style="margin-left: 5%;width: 80%">
                  <p>
                    <a @click="showAnnouncement(record)">{{ record.titile }}</a>
                  </p>
                  <p style="color: rgba(0,0,0,.45);margin-bottom: 0px">{{ record.createTime }} 发布</p>
                </div>
                <div style="text-align: right">
                  <a-tag @click="showAnnouncement(record)" color="blue" v-if="record.priority === 'L'">一般消息</a-tag>
                  <a-tag @click="showAnnouncement(record)" color="orange" v-if="record.priority === 'M'">重要消息</a-tag>
                  <a-tag @click="showAnnouncement(record)" color="red" v-if="record.priority === 'H'">紧急消息</a-tag>
                </div>
              </a-list-item>
              <div style="margin-top: 5px;text-align: center">
                <a-button @click="toMyAnnouncement()" block type="dashed">查看更多</a-button>
              </div>
            </a-list>
          </a-tab-pane>
          <a-tab-pane :tab="msg2Title" key="2">
            <a-list>
              <a-list-item :key="index" v-for="(record, index) in announcement2">
                <div style="margin-left: 5%;width: 80%">
                  <p>
                    <a @click="showAnnouncement(record)">{{ record.titile }}</a>
                  </p>
                  <p style="color: rgba(0,0,0,.45);margin-bottom: 0px">{{ record.createTime }} 发布</p>
                </div>
                <div style="text-align: right">
                  <a-tag @click="showAnnouncement(record)" color="blue" v-if="record.priority === 'L'">一般消息</a-tag>
                  <a-tag @click="showAnnouncement(record)" color="orange" v-if="record.priority === 'M'">重要消息</a-tag>
                  <a-tag @click="showAnnouncement(record)" color="red" v-if="record.priority === 'H'">紧急消息</a-tag>
                </div>
              </a-list-item>
              <div style="margin-top: 5px;text-align: center">
                <a-button @click="toMyAnnouncement()" block type="dashed">查看更多</a-button>
              </div>
            </a-list>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice">
      <a-badge :count="msgTotal">
        <a-icon style="font-size: 16px; padding: 4px" type="bell" />
      </a-badge>
    </span>
    <show-announcement @ok="modalFormOk" ref="ShowAnnouncement"></show-announcement>
    <dynamic-notice :formData="formData" :path="openPath" ref="showDynamNotice" />
    <template v-if="alertCenterMenuAuth">
      <div @click="handleClick($event)" class="gj-notice flex flex-col" v-if="alertModalShow">
        <div class="flex justify-between h-40px mb-10px">
          <div class="font-semibold bg-clip-text flex items-center" style="font-size:20px;">
            <!-- <a-icon theme="twoTone" type="bell" /> -->
            <!-- <a-icon style="font-size: 30px;" theme="twoTone" type="bell" /> -->
            <!--  -->
            <div class="w-30px">
              <a-icon style="font-size: 30px;color:#FF3333;" theme="filled" type="alert" />
            </div>
            <div class="pl-10px">待确认告警</div>
            <div class="px-2px text-lg px-2px" style="color:#FF3333;">{{ lastNoticeTotal }}</div>条
          </div>
          <a-button type="link">
            <router-link to="/alert/center">告警中心</router-link>
          </a-button>
          <div @click="changeAlert(false)" class="text-center mr-10px text-lg w-30px" style="align-self:center;">
            <a-icon style="font-size: 22px;color:#FF3333;" type="minus-square" />
          </div>
        </div>

        <div class="flex-1 noticebox mx-10px pl-20px min-w-300px" v-if="lastNoticeTotal > 0">
          <div class="min-h-50px h-full text">
            <div>
              <span class="font-semibold" style="font-size:14px;">告警名称：</span>
              <span>{{ lastNotice.devId_dictText || '工艺告警' }}</span>
            </div>

            <div class="flex">
              <div class="font-semibold" style="font-size:14px;">告警信息：</div>
              <div class="flex-1 summary pt-13px">{{ lastNotice.summary || '' }}</div>
            </div>

            <div>
              <span class="font-semibold" style="font-size:14px;">告警时间：</span>
              <span>{{ lastNotice.alertTime || '' }}</span>
            </div>
          </div>
        </div>
        <div class="h-40px flex justify-center items-center" v-if="lastNoticeTotal > 0">
          <a-button @click="handleSure(1)" type="danger">全部确认</a-button>
          <a-button @click="handleSure(2)" class="ml-15px" type="danger">确认</a-button>
        </div>

        <a-empty class="mt-20px" v-if="!lastNoticeTotal">
          <span slot="description">无未处理告警</span>
        </a-empty>
      </div>
      <div @click="handleClick($event)" class="minalert" v-else>
        <a-tooltip placement="top">
          <template slot="title">
            <span>展开告警消息</span>
          </template>
          <!-- <a-icon @click="changeAlert(true)" theme="twoTone" type="bell" /> -->
          <a-icon @click="changeAlert(true)" style="font-size: 40px;color:#FF3333;" theme="filled" type="alert" />
        </a-tooltip>
      </div>
    </template>
  </a-popover>
</template>

<script>
  import { getAction, putAction } from '@/api/manage'
  import ShowAnnouncement from './ShowAnnouncement'
  import store from '@/store/'
  import DynamicNotice from './DynamicNotice'
  import { MessageBox } from 'element-ui'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import AudioPlayer from '@/views/monitor/alert/modules/audioPlayer'
  const audioPlayer = new AudioPlayer()
  import { iotAlertAck } from '@/api/device'
  export default {
    name: 'HeaderNotice',
    components: {
      DynamicNotice,
      ShowAnnouncement
    },
    data () {
      return {
        loadding: false,
        url: {
          listCementByUser: '/sys/annountCement/listByUser',
          editCementSend: '/sys/sysAnnouncementSend/editByAnntIdAndUserId',
          queryById: '/sys/annountCement/queryById',
          queryByAlertLevelId: '/alert/alertNotice/queryByAlertLevelId'
        },
        hovered: false,
        announcement1: [],
        announcement2: [],
        msg1Count: '0',
        msg2Count: '0',
        msg1Title: '通知(0)',
        msg2Title: '系统消息(0)',
        stopTimer: false,
        websock: null,
        lockReconnect: false,
        heartCheck: {
          timeout: 60000, // 60秒
          timeoutObj: null,
          serverTimeoutObj: null,
          reset: function() {
            let that = this;
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            this.start();
          },
          start: function() {
            let that = this;
            this.timeoutObj = setTimeout(function() {
              that.websock.send("HeartBeat");
              that.serverTimeoutObj = setTimeout(function() {
                that.websock.close();
              }, that.timeout);
            }, this.timeout);
          }
        },
        formData: {},
        openPath: '',
        lastNotice: {},
        lastNoticeTotal: 0,
        alertModalShow: false
      }
    },
    computed: {
      msgTotal () {
        return parseInt(this.msg1Count) + parseInt(this.msg2Count)
      },
      alertCenterMenuAuth () {
        const hideRoutes = ['/topology/preview', '/topo/monitor'] //组态图预览页面不显示告警图标
        const ifHide = hideRoutes.includes(this.$route.path)
        return this.$store.state.user.alertCenterMenuAuth && !ifHide
      }
    },
    mounted () {
      this.loadData()
      this.timerFun()
      this.initWebSocket()
      this.heartCheckFun()
      this.loadAlert(0)
    },
    destroyed: function () {
      // 离开页面生命周期函数
      this.websocketOnclose()
    },
    methods: {
      handleSure (type) {
        // event.stopPropagation()
        const ids = type == 1 ? this.lastNotice.ids.join() : String(this.lastNotice.id)
        const params = new URLSearchParams()
        params.append('ids', ids)
        iotAlertAck(params).then(res => {
          if (res.success) {
            this.$message.success('告警已处理')
            this.loadAlert(0)
          }
        })
      },
      changeAlert (type) {
        this.alertModalShow = type
      },
      handleClick (event) {
        event.stopPropagation()
      },
      timerFun () {
        this.stopTimer = false
        let myTimer = setInterval(() => {
          // 停止定时器
          if (this.stopTimer == true) {
            clearInterval(myTimer)
            return
          }
          this.loadData()
        }, 30000)
      },
      async loadAlert (type = 0) {
        if (!this.alertCenterMenuAuth) return
        const res = await getAction('alert/iotAlert/list', {
          isAcknowledgement: 0,
          column: 'createTime',
          order: 'desc',
          pageNo: 1,
          pageSize: 9999
        })
        if (res.success) {
          this.lastNoticeTotal = res.result.total
          this.lastNotice = res.result.records[0]

          this.$nextTick(() => {
            if (res.result.records.length == 0) return
            this.lastNotice.ids = res.result.records.map(item => item.id)
          })

          if (res.result.total > 0 && type == 1) {
            this.playSound(this.lastNotice.summary)
          }
        }
      },
      loadData () {
        try {
          // 获取系统消息
          getAction(this.url.listCementByUser)
            .then(res => {
              if (res.success) {
                this.announcement1 = res.result.anntMsgList
                this.msg1Count = res.result.anntMsgTotal
                this.msg1Title = '通知(' + res.result.anntMsgTotal + ')'
                this.announcement2 = res.result.sysMsgList
                this.msg2Count = res.result.sysMsgTotal
                this.msg2Title = '系统消息(' + res.result.sysMsgTotal + ')'
                // if (res.result.sysMsgList.length > 0) {
                //   this.lastNotice = { ...res.result.sysMsgList[0] }
                // }
              }
            })
            .catch(error => {
              console.log('系统消息通知异常', error) //这行打印permissionName is undefined
              this.stopTimer = true
              console.log('清理timer')
            })
        } catch (err) {
          this.stopTimer = true
          console.log('通知异常', err)
        }
        // alert/iotAlert/list
      },
      fetchNotice () {
        if (this.loadding) {
          this.loadding = false
          return
        }
        this.loadding = true
        setTimeout(() => {
          this.loadding = false
        }, 200)
      },
      showAnnouncement (record) {
        putAction(this.url.editCementSend, { anntId: record.id }).then(res => {
          if (res.success) {
            this.loadData()
          }
        })
        this.hovered = false
        if (record.openType === 'component') {
          this.openPath = record.openPage
          this.formData = { id: record.busId }
          this.$refs.showDynamNotice.detail(record.openPage)
        } else {
          this.$refs.ShowAnnouncement.detail(record)
        }
      },
      toMyAnnouncement () {
        this.$router.push({
          path: '/isps/userAnnouncement'
        })
      },
      modalFormOk () { },
      handleHoverChange (visible) {
        this.hovered = visible
      },

      initWebSocket: function () {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = store.getters.userInfo.id
        var url =
          window._CONFIG['domianURL'].replace('https://', 'wss://').replace('http://', 'ws://') + '/websocket/' + userId
        //console.log(url);
        this.websock = new WebSocket(url)
        this.websock.onopen = this.websocketOnopen
        this.websock.onerror = this.websocketOnerror
        this.websock.onmessage = this.websocketOnmessage
        this.websock.onclose = this.websocketOnclose
      },
      websocketOnopen: function () {
        console.log('WebSocket连接成功')
        //心跳检测重置
        this.heartCheck.reset();
        this.heartCheck.start();
      },
      websocketOnerror: function (e) {
        console.log('WebSocket连接发生错误')
        this.reconnect()
      },
      websocketOnmessage: function (e) {
        console.log('-----接收消息-------', e.data)
        if (e.data === 'HeartBeat') {
          console.info('维持心跳=======')
          return
        }
        const data = eval('(' + e.data + ')') //解析对象

        if (data.cmd == 'topic') {
          //系统通知
        //   this.loadData()
          // this.loadAlert(1)
        } else if (data.cmd == 'user') {
          // this.openNotification(data)
          //用户消息
          this.loadAlert(1)
        //   this.loadData()
        }
        //心跳检测重置
        this.heartCheck.reset().start()
      },
      websocketOnclose: function (e) {
        console.log('connection closed (' + e + ')')
        if (e) {
          console.log('connection closed (' + e.code + ')')
        }
        this.reconnect()
      },
      websocketSend (text) {
        // 数据发送
        try {
          this.websock.send(text)
        } catch (err) {
          console.log('send failed (' + err.code + ')')
        }
      },

      async openNotification (data) {
        // var text = data.msgTxt;
        const key = `open${Date.now()}`

        // getAction(this.url.queryById, { id: id }).then((res) => {
        //   if (res.success) {
        //     var record = res.result;
        //     this.showAnnouncement(record);
        //   }
        // })
        const noticeData = await getAction(this.url.queryById, { id: data.msgId })
        if (noticeData.success) {
          //     var record = res.result;
          const h = this.$createElement

          this.$notification.open({
            message: '消息提醒',
            placement: 'bottomRight',
            // description: noticeData.result.msgContent,
            description: h('div', null, [h('p', { domProps: { innerHTML: noticeData.result.msgContent } }, null)]),
            key,
            icon: <a-icon type="bell" style="color: #ff4d4f" />,

            btn: h => {
              return h(
                'a-button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () =>
                      this.$router.push({
                        path: '/alert/center'
                      })
                  }
                },
                '立即处理'
              )
            }
          })
          if (noticeData.result.titile == '告警') {
            this.playSound(noticeData.result.msgContent)
          }
        }
      },

      reconnect () {
        var that = this
        if (that.lockReconnect) return
        that.lockReconnect = true
        //没连接上会一直重连，设置延迟避免请求过多
        setTimeout(function () {
          console.info('尝试重连...')
          that.initWebSocket()
          that.lockReconnect = false
        }, 5000)
      },
      heartCheckFun () {
        var that = this
        //心跳检测,每20s心跳一次
        that.heartCheck = {
          timeout: 20000,
          timeoutObj: null,
          serverTimeoutObj: null,
          reset: function () {
            clearTimeout(this.timeoutObj)
            //clearTimeout(this.serverTimeoutObj);
            return this
          },
          start: function () {
            var self = this
            this.timeoutObj = setTimeout(function () {
              //这里发送一个心跳，后端收到后，返回一个心跳消息，
              //onmessage拿到返回的心跳就说明连接正常
              that.websocketSend('HeartBeat')
              console.info('客户端发送心跳')
              //self.serverTimeoutObj = setTimeout(function(){//如果超过一定时间还没重置，说明后端主动断开了
              //  that.websock.close();//如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
              //}, self.timeout)
            }, this.timeout)
          }
        }
      },

      showDetail (key, data) {
        this.$notification.close(key)
        var id = data.msgId
        getAction(this.url.queryById, { id: id }).then(res => {
          if (res.success) {
            var record = res.result
            this.showAnnouncement(record)
          }
        })
      },
      getWindowVoice () {
        // 获取浏览器中语音 (中文 + 本地服务)
        return window.speechSynthesis.getVoices().find(item => item.localService && item.lang === 'zh-CN')
      },
      filterText (text) {
        // 替换 #number 或 number# 为 number号
        text = text.replace(/#(\d{1,2})/g, '$1号')
        text = text.replace(/(\d{1,2})#/g, '$1号')
        // 替换“当前值：-”、“当前值:-”、“当前值： -”和“当前值: -”为“当前值：负”
        text = text.replace(/当前值\s*[:：]\s*-\s*/g, '当前值：负')
        return text
      },
      handleSpeak (text = '您有新的告警播报!') {
        if (window.speechSynthesis) {
          window.speechSynthesis.cancel()

          const synth = window.speechSynthesis
          const msg = new SpeechSynthesisUtterance()
          msg.text = text // 文字内容
          msg.lang = 'zh-CN' // 使用的语言:中文
          msg.volume = 1 // 声音音量：1
          msg.rate = 1.6 // 语速：1
          msg.pitch = 1.5 // 音高
          msg.voice = this.getWindowVoice()
          synth.speak(msg) //
        }
      },
      playSound (content) {
        audioPlayer.playOnce('answered')
        window.speechSynthesis.cancel()
        setTimeout(() => {
          content = content.replace(/_/g, '') //所有下划线都不朗读
          this.handleSpeak(content)
        }, 1000)
      }
    }
  }
</script>

<style lang="css">

  .header-notice-wrapper {
    top: 50px !important;
  }

</style>
<style lang="less" scoped>
  .header-notice {
    display: inline-block;
    transition: all 0.3s;

    span {
      vertical-align: initial;
    }
  }
  .noticebox {
    overflow-y: scroll;
  }
  .gj-notice {
    transition: all 0.3s;
    position: fixed;
    bottom: 10px;
    right: 10px;
    height: 300px;
    width: 400px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 0 5px #cecece;
    // border: 1px solid red;
    color: #333;
    padding: 10px;
    .summary {
      overflow: hidden;
      text-overflow: ellipsis; /* 超出部分省略号 */
      word-break: break-all; /* break-all(允许在单词内换行。) */
      display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
      -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-line-clamp: 2; /* 显示的行数 */
      line-height: 1.2em;
      width: 250px;
    }
  }
  .minalert {
    position: fixed;
    bottom: 60px;
    right: 12px;
    width: 50px;
    height: 50px;
    z-index: 10;
    cursor: pointer;
    transition: all 0.2s;

    text-align: center;
    border-radius: 50%;
  }
</style>
